
import { types } from "../types/types";

const initialState = {
    sectores: [],
    active: null
}

export const sectoresReducer = ( state = initialState, action ) => {
    switch (action.type) {

        case types.sectoresActive:
            return {
                ...state,
                active: {
                    ...action.payload
                }
            }
        
        case types.sectoresUnactive:
            return {
                ...state,
                active: null
            }
        
        case types.sectoresAddNew:
            return {
                ...state,
                sectores: [ ...state.sectores, action.payload ]
            }

        case types.sectoresLoad:
            return {
                ...state,
                sectores: [ ...action.payload ]
            }
        
        case types.sectoresUpdated:
            return {
                ...state,
                sectores: state.sectores.map(
                    sector => sector._id === action.payload._id
                        ? action.payload
                        : sector
                )
            }

        case types.sectoresDelete:
            return {
                ...state,
                active: null,
                sectores: state.sectores.filter( sector => sector._id !== action.payload )
            }
    
        case types.sectoresLogoutCleaning:
            return {
                ...state,
                active: null,
                sectores: []
            }
    

        default:
            return state;
    }
}